import React, { useState, useEffect } from 'react'
import { Button, Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Modal13 } from '../../Modals/ModalSec1/Modal13'
import { getTechnicalAssistanceApplicant } from '../../../../../services/AsistenciaTecnica/get'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import NumberFormat from 'react-number-format'
import { deleteTechnicalAssistanceApplicant } from '../../../../../services/AsistenciaTecnica/delete'
import swal from 'sweetalert'

export const Table13 = (props) => {
  const {
    IdBeneficiaryType,
    IdTechnicalAssistanceType,
    IdCurrency,
    IdTechnicalAssistanceAnswer,
    RequestedAmount,
    NumberOfApplicants,
    formik,
    setDisabled,
    CurrencyToDollarExchangeRate,
    requestValidate,
  } = props

  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [disableButton, setDisableButton] = useState(false)
  const [body, setBody] = useState({})

  const getTechnicalAssistanceApplicantList = async () => {
    try {
      const response = await getTechnicalAssistanceApplicant(
        IdTechnicalAssistanceAnswer,
      )
      if (response.Success) {
        setData(response.Data)
      }

      if (response.Data.length >= 1) {
        formik('Validate', true)
      } else formik('Validate', false)

      if (response.Data.length === NumberOfApplicants) {
        setDisableButton(true)
        formik('validateTable13', true)
      } else {
        setDisableButton(false)
        formik('validateTable13', false)
      }

      if (response.Data.length >= 1) {
        setDisabled(true)
      } else {
        setDisabled(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await deleteTechnicalAssistanceApplicant(id)

      if (response.Success) {
        swal({
          title: '¡Registro eliminado exitosamente!',
          icon: 'success',
        })
        getTechnicalAssistanceApplicantList()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      IdTechnicalAssistanceAnswer !== '' &&
      IdTechnicalAssistanceAnswer !== null
    )
      getTechnicalAssistanceApplicantList()
  }, [
    IdBeneficiaryType,
    IdTechnicalAssistanceAnswer,
    // RequestedAmount,
    NumberOfApplicants,
    requestValidate,
  ])

  const columns = [
    {
      title: 'Identificador MIPYME',
      field: 'MiPymeIdentifier',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'never',
    },
    {
      title: 'Nombre MIPYME',
      field: 'MiPymeName',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'left',
    },
    {
      title: 'Código proyecto',
      field: 'ProjectCode',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'left',
    },
    {
      title: 'Nombre proyecto',
      field: 'ProjectName',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'left',
    },
    {
      title: 'Monto asistencia técnica',
      field: 'RequestedAmount',
      sorting: false,
      filtering: false,
      align: 'right',
      render: (expense) => (
        <NumberFormat
          value={expense.RequestedAmount}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
  ]

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={data}
            actions={[
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={
                      disableButton
                        ? {}
                        : { backgroundColor: '#27C27D', color: '#FFFFFF' }
                    }
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                    disabled={disableButton}
                    onClick={() => {
                      if (
                        IdCurrency !== null &&
                        RequestedAmount !== 0 &&
                        RequestedAmount !== null
                      ) {
                        setOpen(true)
                      } else {
                        swal({
                          title: `Ha ocurrido un problema`,
                          text: `Debe ingresar la moneda y el monto debe ser mayor a 0`,
                          icon: `error`,
                          closeOnClickOutside: false,
                          closeOnEsc: false,
                          buttons: {
                            catch: {
                              text: 'Continuar',
                              value: 'catch',
                            },
                          },
                        })
                      }
                    }}
                  >
                    Agregar registro
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
              },
              {
                icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                tooltip: 'Editar',
                onClick: (event, rowData) => {
                  setOpen(true)
                  setBody(rowData)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar registro',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdTechnicalAssistanceApplicant)
                    }
                  })
                },
              },
            ]}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{
              Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
              Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            }}
          />
        </Grid>
        <Modal13
          open={open}
          setOpen={setOpen}
          IdBeneficiaryType={IdBeneficiaryType}
          IdTechnicalAssistanceType={IdTechnicalAssistanceType}
          IdCurrency={IdCurrency}
          getTechnicalAssistanceApplicantList={
            getTechnicalAssistanceApplicantList
          }
          body={body}
          setBody={setBody}
          IdTechnicalAssistanceAnswer={IdTechnicalAssistanceAnswer}
          RequestedAmount={RequestedAmount}
          NumberOfApplicants={NumberOfApplicants}
          CurrencyToDollarExchangeRate={CurrencyToDollarExchangeRate}
          data={data}
        />
      </Grid>
    </>
  )
}
